import { IPlayListDetail, IVideoCommentResponse, IVideoComments } from '@ninjacart/nc-nk-core';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IRemoteVideoMetadata } from '../../interface/videoMetadataResponse';
import { IshortVideo, StreamableVideoStatus } from '../../store/interface';
import { useProfileStore } from '../../store/useProfileStore';
import { transformAdaptiveToRemoteMetadata } from '../../utils/conversionUtils';
import { KisaanClient } from '../kisaan/axiosKisaanClient';
// import { transformToPlaylistItem } from '../../utils/transformStreamResponse';
import { IActionDataModel, IAdaptiveActionCard, IFeed } from '@ninjacart/nc-nk-core';
import { useAppPersistenceStore } from '../../store/useAppPersistenceStore';
import paths, { getStreamURI } from '../paths';
import { WorkflowClient } from '../workflow/axiosWorkflowClient';
import { StreamClient } from './axiosStreamClient';
import { IStreamUserStat, IVideosThreds } from './interface';
export const getVideoDetails = async (
  id
): Promise<AxiosResponse<IRemoteVideoMetadata, any> | undefined> => {
  try {
    const uri = `/api/v1/videos/${id}`;
    const axiosRequest: AxiosRequestConfig = {
      headers: {
        'x-device-id': useAppPersistenceStore.getState()?.deviceId,
      },
      validateStatus: (status: number) => {
        return (status >= 200 && status < 309) || status === 403;
      },
    };
    const getMediaMetadata = await StreamClient.get<IRemoteVideoMetadata>(uri, axiosRequest);
    return getMediaMetadata;
  } catch (error) {
    console.error('Unable to get video details.', error);
    return undefined;
  }
};

type FeedVideo = IshortVideo | undefined;

export const getStreamableShortFeed = async (item: FeedVideo) => {
  try {
    if (item?.card) {
      const parts = item?.card?.url?.split('/');
      const id = parts[parts.length - 1];
      const mediaData = await getVideoDetails(id);
      if (mediaData?.status === 403) {
        item.videoStatus = StreamableVideoStatus.BLOCKED;
        throw new Error('Video is blocked!!!');
      }

      if (mediaData?.data) {
        item.streamVideoUri = mediaData?.data?.streamingPlaylists?.[0]?.playlistUrl;
        item.videoUri =
          mediaData?.data?.streamingPlaylists?.[0]?.files?.[0]?.fileUrl ??
          item?.media_attachments?.[0]?.url ??
          undefined;
        item.poster = `${getStreamURI()}${mediaData?.data?.previewPath}`;

        if (item.videoUri) {
          item.videoStatus = StreamableVideoStatus.OK;
        }
      }

      if (!item.videoUri) {
        throw new Error('Video url not found!');
      }

      item.id = mediaData?.data?.id?.toString() ?? '';
      return item;
    }
  } catch (err) {
    console.error('Unable to load streamable feed. ', err);
    throw err;
  }

  // return undefined;
};

export const getPlayBackUrl = async (item) => {
  try {
    if (item?.card) {
      const parts = item?.card?.url?.split('/');
      const id = parts[parts.length - 1];
      const uri = paths.getPlayBackUrl(id);
      const getMediaMetadata = await StreamClient.get<IRemoteVideoMetadata>(uri);

      if (getMediaMetadata?.data?.streamingPlaylists?.[0]?.playlistUrl) {
        return getMediaMetadata.data.streamingPlaylists?.[0]?.playlistUrl;
      }
    } else if (item?.media_attachments?.length > 0) {
      return item?.media_attachments?.[0]?.url;
    } else {
      console.log('item *****=>', item);
      const uri = paths.getPlayBackList(item?.id);
      const getMediaMetadata = await StreamClient.get<IRemoteVideoMetadata>(uri);
      if (getMediaMetadata?.data?.streamingPlaylists?.[0]?.playlistUrl) {
        return getMediaMetadata.data;
      }
    }

    return '';
  } catch (error) {
    console.log('error getPlayBackUrl', error);
    throw error;
  }
};

export const getPlayBackDetailAPI = async (id) => {
  try {
    const uri = paths.getPlayBackList(id);
    const data = await StreamClient.get<IRemoteVideoMetadata>(uri);
    return data.data;
  } catch (error) {
    console.log('error getPlayBackDetailAPI', error);
    throw error;
  }
};

export const getRecommendList = async (payload): Promise<any> => {
  try {
    const deviceId = useAppPersistenceStore.getState()?.deviceId;
    const uri = paths.getRecommendList(payload, deviceId);
    const data = await KisaanClient.get<IFeed<IAdaptiveActionCard<IActionDataModel>[]>>(uri);
    return data;
  } catch (error) {
    console.log('error getRecommendList', error);
    throw error;
  }
};

export const getPlayListItems = async (
  id: string,
  start: number,
  count: number
): Promise<IPlayListDetail | undefined> => {
  try {
    const uri = paths.getPlayListItems(id, start, count);
    const response = await StreamClient.get<IPlayListDetail>(uri);
    return response.data;
  } catch (error) {
    console.log('error getPlayListItems', error);
    throw error;
  }
};

export const onVideoLike = async (id: string, like: string): Promise<string | null> => {
  try {
    const streamToken = useProfileStore?.getState()?.streamConfig?.access_token;

    if (id && streamToken) {
      const uri = paths.peerTubeLikeVideo(id);
      const response = await StreamClient.put<string>(uri, { rating: like });
      return response.status === 204 ? 'like' : 'none';
    }
    return like;
  } catch (error) {
    console.log('Error PeerTube like Video', error.toString());
  }
  return like;
};

export const getVideoComments = async (payload): Promise<IVideoComments | undefined> => {
  try {
    if (payload?.id) {
      const uri = paths.peerTubeGetComments(payload);
      const response = await StreamClient.get(uri);
      return response.data;
    }
  } catch (error) {
    console.log('error PeerTubegetVideoComments', error);
    throw error;
  }
};

export const getVideoRating = async (id: string): Promise<{ id: string; rating: string }> => {
  try {
    const uri = paths.peerTubeGetVideoRatings(id);
    const response = await StreamClient.get<{ id: string; rating: string }>(uri);
    return response.data;
  } catch (error) {
    console.log('error PeerTubeGetVideoRating', error);
    throw error;
  }
};

export const postCommentOnVideo = async (id: string, text: string): Promise<IVideoCommentResponse> => {
  try {
    const uri = paths.peerTubePostCommentsOnVideo(id);
    const response = await StreamClient.post<IVideoCommentResponse>(uri, { text: text });
    return response.data;
  } catch (error) {
    console.log('error PeerTubePostCommentOnVideo', error);
    throw error;
  }
};
export const updateLikedStream = async (id: string): Promise<any> => {
  try {
    const uri = paths.updateLikeCountPeerTubeApi(id);
    const response = await StreamClient.get<any>(uri);
    return response.data;
  } catch (error) {
    console.log('error PeerTubeUpdateLikedStream', error);
    throw error;
  }
};

export async function getPlayListItem(payload): Promise<any> {
  try {
    const data = await getRecommendList(payload);
    const res = data?.data?.data?.filter((x) => x.actionData?.content?.id !== payload?.videoId);
    if (res) {
      const videoMetadatas: any[] = res.map((item) => {
        if (item?.type == 'BANNER_AD') {
          return item;
        } else {
          return transformAdaptiveToRemoteMetadata(item);
        }
      });
      return {
        items: videoMetadatas,
        offset: data?.data?.offset,
        count: data?.data?.count,
      };
    }
    return undefined;

    // const itemsPromises: Promise<IRemoteVideoMetadata>[] = res?.map(
    //   async (longVideoItem, index) => {
    //     const data = await getVideoDetails(longVideoItem?.actionData?.content?.id);
    //     return data?.data!;
    //   }
    // );

    // const items = await Promise.allSettled(itemsPromises);
    // const resolved = items
    //   .filter((x): x is PromiseFulfilledResult<IRemoteVideoMetadata> => x.status === 'fulfilled')
    //   .map((x) => x.value);
    // // const resolvedToPlayListItem: PlayListItem[] = resolved?.map((item) =>
    // //   transformToPlaylistItem(item)
    // // );

    // // const currentIndex = res.data?.findIndex((item) => item.id === currentLongVideoSelected?.id);
    // // setLongStreamVideos([...longStreamVideos, ...resolved]);
    // return resolved.filter((x) => x?.id > 0);
  } catch (error) {
    console.error('Error fetching playlist items:', error);
    return undefined;
  }
}

export async function getPlayListStreamItem(id): Promise<IRemoteVideoMetadata[] | undefined> {
  try {
    const res: any = await getPlayListItems(id, 0, 10);

    const itemsPromises: Promise<IRemoteVideoMetadata | undefined>[] = res.data.map(
      async (longVideoItem, index) => {
        const data = await getVideoDetails(longVideoItem?.video?.shortUUID);
        return data?.data!;
      }
    );

    const items = await Promise.allSettled(itemsPromises);
    const resolved = items
      .filter((x): x is PromiseFulfilledResult<IRemoteVideoMetadata> => x.status === 'fulfilled')
      .map((x) => x.value);
    // const resolvedToPlayListItem: PlayListItem[] = resolved.map((item) =>
    //   transformToPlaylistItem(item.actionData.content)
    // );

    // const currentIndex = res.data?.findIndex((item) => item.id === currentLongVideoSelected?.id);
    // setLongStreamVideos([...longStreamVideos, ...resolved]);
    return resolved;
  } catch (error) {
    console.error('Error fetching getPlayListStreamItem items:', error);
    return undefined;
  }
}

export async function getPlayListStreamItemES(id): Promise<IRemoteVideoMetadata[]> {
  try {
    const res = await getPlayListItems(id, 0, 10);
    if (!res?.data?.length) {
      return [];
    }

    const streamIds = res.data.map((ele: { id: number }) => ele.id).filter((x) => x && x);
    const payload = { streamIds };
    if (!streamIds.length) return [];

    const videoDetails = await getVideoDetailsES(payload);

    if (videoDetails?.length) {
      return videoDetails.map((item) => transformAdaptiveToRemoteMetadata(item));
    }

    return [];
  } catch (error) {
    console.error('Error fetching getPlayListStreamItem items:', error);
  }
  return [];
}

export const getVideoDetailsES = async (
  payload: object
): Promise<
  IAdaptiveActionCard<IActionDataModel<IRemoteVideoMetadata>>[] | undefined | IRemoteVideoMetadata[]
> => {
  try {
    const response = await KisaanClient.post(paths.getVideoDetailES(true), payload);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const getVideoDetailsESRaw = async (
  payload: object
): Promise<IRemoteVideoMetadata[] | undefined> => {
  try {
    const response = await WorkflowClient.post(paths.getVideoDetailES(false), payload);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const getStreamUserDetails = async (): Promise<IStreamUserStat | null> => {
  try {
    const uri = paths.getStreamUser();
    const streamToken = useProfileStore?.getState()?.streamConfig?.access_token;
    // console.log('streamToken', streamToken);
    if (!streamToken) return null;
    const response = await StreamClient.get<IStreamUserStat>(uri);
    return response.data;
  } catch (error) {
    console.log('error PeerTube like Video', error.toString());
    throw error;
  }
};

export const updateVideoStreamPlayback = async (
  id: string,
  currentTime: number,
  deviceId?: string
): Promise<any> => {
  try {
    const uri = paths.updateVideoStreamPlayback(id);
    const response = await StreamClient.post<any>(uri, { currentTime: currentTime, deviceId });
    return response?.data;
  } catch (error) {
    console.log('error updateVideoStreamPlayback', error);
  }
};
